import SEO from "../components/SEO";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="privacy-page">
      <SEO
        title="Privacy Policy | Indiana Accident Aid"
        description="How Indiana Accident Aid collects, uses, shares, and protects your information when you use our free attorney-matching service."
      />
      <h1 className="font-display font-black text-4xl sm:text-5xl text-forest mb-6">Privacy Policy</h1>
      <p className="text-sm text-forest/60 mb-10">Last updated: {new Date().getFullYear()}</p>

      <div className="space-y-6 text-forest/80 leading-relaxed text-base">
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Information We Collect</h2>
          <p>
            When you submit a case-review or contact form, we collect the information you provide —
            typically your name, phone number, email address, and a description of your accident or
            claim. We also collect standard technical data (such as pages viewed and general device
            information) through analytics tools to understand how the site is used.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To evaluate your inquiry and connect you with one or more independent attorneys who may be able to help.</li>
            <li>To respond to your questions and communicate about your request.</li>
            <li>To operate, secure, and improve this website.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">How We Share Information</h2>
          <p>
            To provide our matching service, we may share the details you submit with one or more
            independent attorneys or law firms so they can contact you about a free, no-obligation
            consultation. We may also use trusted service providers (for example, hosting and
            analytics) that process data on our behalf. <strong>We do not sell your personal
            information.</strong>
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Cookies &amp; Analytics</h2>
          <p>
            We use cookies and analytics (such as Google Analytics) to measure traffic and improve the
            experience. You can control cookies through your browser settings. Disabling cookies may
            affect some site features.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Your Choices</h2>
          <p>
            You may request that we access, update, or delete the personal information you have
            submitted, subject to legal limitations. To make a request, contact us through the{" "}
            <a href="/contact" className="text-terracotta font-semibold hover:underline">contact page</a>.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Data Security &amp; Retention</h2>
          <p>
            We use reasonable safeguards to protect your information and retain it only as long as
            needed for the purposes described above or as required by law. No method of transmission or
            storage is completely secure.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Children's Privacy</h2>
          <p>This site is intended for adults and is not directed to children under 13.</p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Material changes will be reflected by
            the &ldquo;Last updated&rdquo; date above.
          </p>
        </section>
      </div>
    </div>
  );
}
